module.exports = __webpack_public_path__ + "img/health.12c4d4cc.png";